import {
  clearOldInteractionsEntries,
  STORAGE_KEYS,
  universalTrackRoomClicked,
} from '@/services/interactions-tracker';

export function trackRoomClicked(roomId) {
  universalTrackRoomClicked(STORAGE_KEYS.VENUE_PAGE, roomId);
}

export function clearOldVenuePageInteractionsEntries() {
  clearOldInteractionsEntries(STORAGE_KEYS.VENUE_PAGE);
}
